module.exports = __webpack_public_path__ + "img/2025-12-20b_4.5d1a4750.jpg";